export const PROCESS = [
  {
    n: "01",
    title: "Understand the problem",
    body: "Before writing a single line we sit with the problem — who is it for, what breaks without it, what would make it genuinely useful. Most of the work happens here."
  },
  {
    n: "02",
    title: "Build lean, ship fast",
    body: "We move quickly, keep the stack simple and cut whatever doesn't serve the core idea. A working thing always beats a perfect spec."
  },
  {
    n: "03",
    title: "Iterate with real users",
    body: "Real feedback over assumptions, every time. We'd rather hear something's broken from a user than discover it quietly in production."
  },
  {
    n: "04",
    title: "Make it last",
    body: "Clean code, clear docs, sensible architecture. We build things we'd be comfortable handing off to someone else — or returning to two years later."
  }
];